export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="m17.5 11.1.092.005a.9.9 0 0 1 0 1.79l-.092.005h-11a.9.9 0 0 1 0-1.8h11Z"/>
</svg>
`;
